const mediaItems = [
  {
    title: '2026下半年最值得关注的科技趋势盘点',
    source: '科技频道',
    views: '12.8万',
    duration: '08:32',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20technology%20concept%20scene%20with%20floating%20digital%20interface%20elements%2C%20warm%20cream%20background%2C%20clean%20minimalist%20design%2C%20soft%20ambient%20lighting%2C%20abstract%20geometric%20shapes%20in%20warm%20orange%20and%20coral%20tones%2C%20editorial%20quality%20composition&width=800&height=450&seq=media-tech-01&orientation=landscape',
    tag: '科技',
    tagColor: 'primary',
  },
  {
    title: '独家解读：娱乐圈最新爆料事件全复盘',
    source: '吃瓜前线',
    views: '25.3万',
    duration: '12:15',
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20concept%20with%20abstract%20microphone%20and%20spotlight%20elements%20on%20a%20warm%20neutral%20background%2C%20artistic%20minimalist%20composition%2C%20soft%20coral%20and%20amber%20color%20palette%2C%20editorial%20magazine%20style%20layout%2C%20clean%20aesthetic&width=800&height=450&seq=media-ent-02&orientation=landscape',
    tag: '吃瓜',
    tagColor: 'accent',
  },
  {
    title: '618购物节省钱攻略：导航直达各大平台优惠',
    source: '购物指南',
    views: '18.6万',
    duration: '15:40',
    image: 'https://readdy.ai/api/search-image?query=Online%20shopping%20concept%20with%20floating%20shopping%20bags%20and%20discount%20tags%20on%20a%20minimal%20warm%20background%2C%20clean%20composition%20with%20soft%20orange%20and%20cream%20tones%2C%20modern%20ecommerce%20aesthetic%2C%20editorial%20product%20photography%20style&width=800&height=450&seq=media-shop-03&orientation=landscape',
    tag: '购物',
    tagColor: 'primary',
  },
  {
    title: '导航123使用指南：让你的上网效率翻倍的秘诀',
    source: '实用教程',
    views: '9.2万',
    duration: '06:48',
    image: 'https://readdy.ai/api/search-image?query=Digital%20navigation%20and%20productivity%20concept%20with%20abstract%20compass%20and%20direction%20indicators%20on%20a%20warm%20cream%20background%2C%20minimalist%20geometric%20design%2C%20soft%20coral%20accent%20touches%2C%20clean%20professional%20aesthetic&width=800&height=450&seq=media-guide-04&orientation=landscape',
    tag: '教程',
    tagColor: 'secondary',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">精彩视频</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[480px] mx-auto">
            精选热点视频内容，涵盖科技、吃瓜、购物攻略等热门领域
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/60 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  width="800"
                  height="450"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <div className="absolute bottom-2 right-2 bg-black/70 text-background-50 text-[10px] font-medium px-2 py-0.5 rounded">
                  {item.duration}
                </div>
                <div className="absolute top-3 left-3">
                  <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${
                    item.tagColor === 'primary' ? 'bg-primary-500 text-background-50' :
                    item.tagColor === 'accent' ? 'bg-accent-500 text-background-50' :
                    'bg-secondary-500 text-background-50'
                  }`}>
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-semibold text-sm md:text-base text-foreground-900 mb-2 line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{item.source}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line text-[10px]"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}